export default "3ba0a3cdf9bc77b1.ttf"